import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  IconButton,
  Link,
} from '@mui/material';
import {
  Facebook,
  Instagram,
  Twitter,
  X,
  YouTube,
  Spa,
  Pinterest,
} from '@mui/icons-material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'secondary.main',
        color: 'white',
        py: 6,
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <Grid container spacing={4}>
          {/* Brand Section */}
          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Spa sx={{ fontSize: 32 }} />
                <Typography
                  variant="h5"
                  sx={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontWeight: 700,
                  }}
                >
                  Veda & Vine
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Your sanctuary for holistic wellness, where ancient wisdom meets
                modern healing practices.
              </Typography>
              <Stack direction="row" spacing={1}>
                <IconButton
                component="a"
                href="https://www.facebook.com/vedaandvine"
                target="_blank"
                rel="noopener noreferrer"
                  sx={{
                    color: 'white',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  <Facebook />
                </IconButton>
                <IconButton
                component="a"
                href="https://www.instagram.com/vedaandvine/"
                target="_blank"
                rel="noopener noreferrer"
                  sx={{
                    color: 'white',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  <Instagram />
                </IconButton>
                <IconButton
                component="a"
                href="https://x.com/vedaandvine"
                target="_blank"
                rel="noopener noreferrer"
                  sx={{
                    color: 'white',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  <X />
                </IconButton>
                <IconButton
                component="a"
                href="https://www.pinterest.com/vedaandvine/"
                target="_blank"
                rel="noopener noreferrer"
                  sx={{
                    color: 'white',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  <Pinterest />
                </IconButton>
              </Stack>
            </Stack>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              {['Home', 'About', 'Services', 'Philosophy', 'Testimonials', 'Contact'].map(
                (link) => (
                  <Link
                    key={link}
                    href={`#${link.toLowerCase()}`}
                    sx={{
                      color: 'white',
                      opacity: 0.8,
                      textDecoration: 'none',
                      '&:hover': {
                        opacity: 1,
                        color: 'primary.main',
                      },
                      transition: 'all 0.3s ease',
                    }}
                  >
                    {link}
                  </Link>
                )
              )}
            </Stack>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Contact
            </Typography>
            <Stack spacing={1}>
              {/* <Typography variant="body2" sx={{ opacity: 0.8 }}>
                123 Wellness Way
                <br />
                Harmony City, HC 12345
              </Typography> */}
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Phone: +91-9988774662
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.8 }}>
                Email: vedaandvine@gmail.com
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box
          sx={{
            mt: 6,
            pt: 3,
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            © {currentYear} Veda & Vine. All rights reserved. | Designed with ❤️ for
            your wellness journey.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
